import { axiosInstance } from '@configs/axios/axiosInstance';

import type { GetUsersRequest, GetUsersResult } from './getUsers.types';

import { User } from '../types/user.types';

/**
 * Fetch a paginated list of B2C users for a given organization.
 * Endpoint: GET /users
 *
 * `organizationId` is sent as the X-Organization-ID request header.
 * Pagination, sorting, and filter params are sent as query parameters.
 * Total count is returned via the `x-total-count` response header.
 */
export async function getUsers(
  params: GetUsersRequest
): Promise<GetUsersResult> {
  const { organizationId, ...queryParams } = params;

  const response = await axiosInstance.get<User[]>('/users', {
    params: queryParams,
    headers: { 'X-Organization-ID': organizationId },
  });

  const total = Number(response.headers['x-total-count']) || 0;

  return {
    elements: response.data,
    total,
  };
}
